(() => {
  const ObserveIntersection = (selector, config, callback) => {
    let observer = new IntersectionObserver(function(entries) {
      callback(entries);
    }, config);
    
    observer.observe(document.querySelector(selector), config);
  
    return observer;
  }

  const ConvertStringToHTML = (str) => {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }

  const SetCountdown = (p_options) => {
    var countdownTimer;
    
    function cancel() {
      clearInterval(countdownTimer);
    }
    
    function format2digits(n) {
      return ("0" + n).slice(-2);
    }
    
    countdownTimer = setInterval(function() {
      var counter_text = '', distance;
      // Get todays date and time
      var until = new Date(p_options.date_timestamp);
      var now = new Date();
  
      // Find the distance between now an the count down date
      distance = until.getTime() - now.getTime();
  
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
      // console.log(days, hours, minutes, seconds);
      
      /*
      if (days > 0) {
        counter_text += days + "D ";
      }
      */

      if (days > 0) {
        hours += (days * 24);
      }

      counter_text += `${ p_options.prefix }`;
      counter_text += `${ (hours < 10) ? format2digits(hours) : hours }:`
      counter_text += `${ format2digits(minutes) }:${ format2digits(seconds) }`;
      
      // Show countdown text
      document.querySelector(p_options.selector).textContent = counter_text;
      
      if (distance <= 0) {
        cancel();
        if (p_options.onComplete && typeof p_options.onComplete == 'function') {
          p_options.onComplete();
        }
      }
    }, 500);
    
    return {
      cancel: cancel
    };
  }  

  // Length option selection helper
  document.addEventListener('change-option-value', (e) => {
    //console.log(e);
    let option = e.detail.option;
    let value = e.detail.value;

    if (option.name == 'Length' || option.name == 'Size') {
      let $helper = document.querySelector(`.helper-${ option.name.toLowerCase() }`);
      if (!$helper) return;

      switch(value) {
        // pants
        case '28"':
          $helper.innerHTML = `(for heights 5'5 to 5'8)`;
          break;
        case '30"':
          $helper.innerHTML = `(for heights 5'9 to 5'10)`;
          break;
        case '32"':
          $helper.innerHTML = `(for heights 5'11 to 6'1)`;
          break;
        case '34"':
          $helper.innerHTML = `(for heights 6'2 to 6'4)`;
          break;
        case '36"':
          $helper.innerHTML = `(for heights 6'5 to 6'8)`;
          break;

        // boxers
        case 'S': 
          $helper.innerHTML = `Small (28-30")`;
          break;
        case 'M': 
          $helper.innerHTML = `Medium (31-33")`;
          break;
        case 'L': 
          $helper.innerHTML = `Large (34-36")`;
          break;
        case 'XL': 
          $helper.innerHTML = `X-Large (37-39")`;
          break;
        case '2X': 
          $helper.innerHTML = `2X-Large (40-42")`;
          break;
      }
    }

    // update other product urls to switch same variant
    let $form = e.target.closest('.ProductForm__Variants');
    let product_type = $form.closest('.Product__InfoWrapper').dataset.template;
    let isPant = product_type == 'pants';
    let isBoxer = product_type == 'boxers';
    let selected_values = [...$form.querySelectorAll('input:not(.linked-swatch):checked')].map($input => $input.value);
    $form.querySelectorAll('.LinkedProduct-Swatch a').forEach(($item) => {
      let product_handle = $item.dataset.handle;
      let template_view = $item.dataset.template_view;
      let product_variants = JSON.parse($item.dataset.variants) || [];
      let matching_variant;
      if (isPant) {
        matching_variant = product_variants.find((v) => {
          return [v.options[1], v.options[2]].join('/') == selected_values.join('/');
        });  
      }
      if (isBoxer) {
        matching_variant = product_variants.find((v) => {
          return [v.options[0], v.options[2]].join('/') == selected_values.join('/');
        });
      }
      if (matching_variant) {
        let url_parts = [];
        if (template_view) {
          url_parts.push(`view=${ template_view }`);
        }
        url_parts.push(`variant=${ matching_variant.id }`);
        let matching_variant_url = `/products/${ product_handle }?${ url_parts.join('&') }`;
        $item.setAttribute('href', matching_variant_url);
      }
    });
  });

  // Sticky add to cart on mobile
  document.addEventListener('init-sticky-product-atc', (e) => {
    if (!theme_settings.enable_sticky_atc) return;
    
    let $atc_btn = e.target;
    let isMobile = window.matchMedia('(max-width: 640px)').matches;

    let $atc_btn_container = document.querySelector('.ProductForm__BuyButtons');
    $atc_btn_container.style.minHeight = `${ $atc_btn_container.clientHeight }px`;

    let $stickyBar = document.querySelector('.product-sticky-bar');    

    ObserveIntersection('.ProductForm__BuyButtons', {}, (i) => {
      let intersectingItem = i[0];
      if (isMobile) {
        if (theme_settings.sticky_atc_position == 'all') {
          // $atc_btn.classList.toggle('fixed', !intersectingItem.isIntersecting);
          $stickyBar.classList.toggle('active', !intersectingItem.isIntersecting);
        }
        else {
          // $atc_btn.classList.toggle('fixed', !intersectingItem.isIntersecting && (window.scrollY > intersectingItem.target.offsetTop));
          $stickyBar.classList.toggle('active', !intersectingItem.isIntersecting && (window.scrollY > intersectingItem.target.offsetTop));
        }  
      }
      else {
        $stickyBar.classList.toggle('active', !intersectingItem.isIntersecting && (window.scrollY > intersectingItem.target.offsetTop));
      }
    });

    const ScrollToProductForm = () => {
      window.scrollTo({
        top: isMobile ? document.querySelector('.ProductForm__Variants').offsetTop : 0,
        behavior: 'smooth'
      });
    }

    // mobile
    $atc_btn.addEventListener('click', (e) => {
      if ($atc_btn.classList.contains('fixed')) {
        e.preventDefault();
        e.stopPropagation();
        ScrollToProductForm();
      }
    });

    // desktop
    $stickyBar.querySelector('.ProductForm__AddToCart').addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      ScrollToProductForm();
    });
  });

  // Sticky add to cart bar - custom section with icons
  document.addEventListener('init-sticky-bar-custom', (e) => {
    // console.log(e);
    let $section = e.target;
    let $stickyBar = document.querySelector('.custom-sticky-bar');
    if (!$stickyBar) return;

    ObserveIntersection(`#${ $section.id }`, {}, (i) => {
      let intersectingItem = i[0];
      $stickyBar.classList.toggle('active', !intersectingItem.isIntersecting && (window.scrollY > intersectingItem.target.offsetTop));
    });

    // const ScrollToSection = () => {
    //   window.scrollTo({
    //     top: $section.offsetTop,
    //     behavior: 'smooth'
    //   });
    // }
    // $stickyBar.querySelector('.ProductForm__AddToCart').addEventListener('click', (e) => {
    //   e.preventDefault();
    //   e.stopPropagation();
    //   ScrollToSection();
    // });
  });

  // announcement - countdown timer
  document.addEventListener('init-countdown-timer', (e) => {
    // console.log(e);
    let date_now = new Date();
    let selector = `#${ e.detail.id } .countdown`;
    let enddate_timestamp = e.detail.date_ts;
    let session_timer_key = 'announcement_timestamp_Xhrs';
    let reset_timer_every_x = e.detail.reset_timer_every_x;
    if (e.detail.reset_timer && !localStorage.getItem(session_timer_key)) {
      date_now.setTime(date_now.getTime() + (reset_timer_every_x*60*60*1000));
      // date_now.setDate(date_now.getDate() + (24 * (reset_timer_every_x / 24)) + (reset_timer_every_x % 24));
      enddate_timestamp = date_now.toISOString();
      localStorage.setItem(session_timer_key, enddate_timestamp);
    }
    if (e.detail.reset_timer && localStorage.getItem(session_timer_key)) {
      enddate_timestamp = localStorage.getItem(session_timer_key);
    }

    SetCountdown({
      date_timestamp: enddate_timestamp,
      selector: selector,
      prefix: 'Ending in ',
      onComplete: () => {
        document.querySelector(selector).classList.add('u-visually-hidden');
        localStorage.removeItem(session_timer_key);
      }
    })
  });

  // gallery thumbs swiper
  document.addEventListener('product-gallery-thumbs-init', (e) => {
    // console.log(e);
    let $thumbs = e.target;
    let $main = $thumbs.closest('.Product__Gallery');
    let $mainCarousel = $main.querySelector('.Product__Slideshow');
    let mq_mobile = window.matchMedia('(max-width: 640px)');
    let is_Mobile = mq_mobile.matches;
    let isFlickityEnabled = $mainCarousel.classList.contains('flickity-enabled');
    if (!isFlickityEnabled) return;

    let slidesPerView, thumbs_height, height;
    let $thumb = $thumbs.querySelector('.Product__SlideshowNavImage');
    if (!is_Mobile) {
      height = $main.offsetHeight;
      $thumbs.style.setProperty('--thumbs-gallery-height', `${ height }px`);  
      slidesPerView = height / ($thumb.offsetHeight + 10);
      thumbs_height = $thumb.clientHeight * $thumbs.querySelectorAll('.Product__SlideshowNavImage').length;
    }

    // first thumb selected
    $thumbs.querySelector('.Product__SlideshowNavImage').classList.add('is-selected');

    let swiper_thumb_options = {
      centeredSlides: is_Mobile ? true : (thumbs_height > height),
      centeredSlidesBounds: true,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      direction: is_Mobile ? 'horizontal' : 'vertical',
      slidesPerView: is_Mobile ? 5.5 : slidesPerView,
      spaceBetween: is_Mobile ? 10 : 15
    };

    let swiperThumbs = new Swiper($thumbs, swiper_thumb_options);

    $thumbs.addEventListener('click', (evt) => {
      e.preventDefault();
      // console.log(evt);
      let $thumb = evt.target.closest('.swiper-slide');
      if ($thumb) {
        setTimeout(() => {
          $thumb.querySelector('.Product__SlideshowNavImage').classList.add('is-selected');
          let thumbIndex = $thumb.dataset.itemIndex;
          swiperThumbs.slideTo(thumbIndex);
        }, 0);
      }

      let FlickityMain = Flickity.data('.Product__Slideshow');
      if (FlickityMain) {
        let index = evt.target.closest('.Product__SlideshowNavImage').dataset.imageMediaPosition;
        FlickityMain.select(index);
      }
    });
  });

  document.addEventListener('flickity:init', (e) => {
    // console.log(e);
    let flickity = e.detail.flickity;
    // pdp - on main gallery change, update thumbs
    if (flickity.element.classList.contains('Product__Slideshow')) {
      flickity.on('settle', () => {
        let swiper_thumbs = document.querySelector('.Product__SlideshowNav .gallery-thumbs').swiper;
        // console.log(swiper_thumbs)
        if (!swiper_thumbs) return;
  
        swiper_thumbs.slideTo(flickity.selectedIndex);
        swiper_thumbs.slides[flickity.selectedIndex].querySelector('.Product__SlideshowNavImage').classList.add('is-selected');
      });
    }
  });

  // on variant change, update product images
  document.addEventListener('variant:changed', (e) => {
    // console.log(e);
    let $section = document.querySelector('[data-group_images_by_color="true"]');
    let variant_color = e.detail.variant[$section.dataset.color_option_id];
    let hasColorChanged = variant_color !== $section.dataset.color;

    if ($section && hasColorChanged) {
      (async() => {
        let variant_res = await fetch(`${ window.location.pathname }?variant=${ e.detail.variant.id }&sections=main-product`).then(res => res.json());
        // console.log(variant_res);

        // Replace images and initialize slideshow
        let $variant_res = ConvertStringToHTML(variant_res['main-product']);
        // console.log($variant_res);
        $section.innerHTML = $variant_res.querySelector('[data-group_images_by_color="true"]').innerHTML;

        // add index
        $section.querySelectorAll('.Product__SlideshowNavImage').forEach(($item, index) => {
          $item.dataset.imageMediaPosition = index;
        });

        $section.dataset.color = variant_color;
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('init:ProductSlideshow'));
        }, 0);

        setTimeout(() => {
          let $thumbs = document.querySelector('.Product__SlideshowNav--thumbnails');
          $thumbs.dispatchEvent(new CustomEvent('product-gallery-thumbs-init'));
        }, 250);
      })();
    }
  });

  // re-initialize on resize
  let mq_640px = window.matchMedia('(max-width: 640px)');
  let mq_768px = window.matchMedia('(min-width: 768px)');
  let mq_1025px = window.matchMedia('(min-width: 1025px)');
  [mq_640px, mq_768px, mq_1025px].forEach(mq => {
    mq.addEventListener('change', (e) => {
      // console.log(e);
      Flickity.data('.Product__Slideshow').resize();
  
      let swiper_thumbs = document.querySelector('.gallery-thumbs').swiper;
      if (swiper_thumbs) {
        swiper_thumbs.destroy();
      }
      setTimeout(() => {
        let $thumbs = document.querySelector('.gallery-thumbs');
        $thumbs.dispatchEvent(new CustomEvent('product-gallery-thumbs-init', {bubbles: true}));
      }, 0);
    });    
  });

  if (window.theme.cart_enable_url_change) {
    // Cart events
    const CartURLUpdate = (e) => {
      // console.log(e)
      var newloc = new URL(window.location.href);
      let cart_state = 'off';
      let event_type = e ? e.type : 'pageload';
      cart_state = event_type.indexOf('open') !== -1 ? 'on' : 'off';

      if (!newloc.searchParams.get('cart')) {
        newloc.searchParams.append('cart', cart_state);
      }
      else {
        newloc.searchParams.set('cart', cart_state);
      }
      window.history.replaceState("", "", newloc);
    }

    CartURLUpdate(); // on page load
    document.addEventListener('cart:drawer:open', CartURLUpdate);
    document.addEventListener('cart:drawer:close', CartURLUpdate);
  }

  document.addEventListener('alpine:init', () => {
    let pathname = window.location.pathname;
    let urlParams = new URLSearchParams(window.location.search);
    let isPantPage = pathname.indexOf('pant') !== -1;
    let isBoxerPage = pathname.indexOf('boxer') !== -1;
    let pant_view, boxer_view;

    if (isPantPage) {
      pant_view = urlParams.get('view');

      switch(pant_view) {
        case 'pants-day1':
          boxer_view = 'boxers-day1'; 
          break;
        case 'pants-nom':
          boxer_view = 'boxers-nom'; 
          break;
        case 'pants-nom1':
          boxer_view = 'boxers-nom1'; 
          break;
        case 'pants':
          boxer_view = 'boxers'; 
          break;
        case 'dir-ls1':
          boxer_view = 'boxers-dir-ls1'; 
          break;
      }
    }

    if (isBoxerPage) {
      boxer_view = urlParams.get('view');

      switch(boxer_view) {
        case 'boxers-day1':
          pant_view = 'pants-day1'; 
          break;
        case 'boxers-nom':
          pant_view = 'pants-nom'; 
          break;
        case 'boxers-nom1':
          pant_view = 'pants-nom1'; 
          break;
        case 'boxers':
          pant_view = 'pants'; 
          break;
        case 'boxers-dir-ls1':
          pant_view = 'dir-ls1'; 
          break;
      }
    }


    // Update navigation header pdp links to have same view
    if (pant_view || boxer_view) {
      $links_to_update = [
        ...document.querySelectorAll(`.shopify-section--header a[href*="/products"]`),
        ...document.querySelectorAll(`.shopify-section--footer a[href*="/products"]`)
      ];
      $links_to_update.forEach(($a) => {
        let url = $a.getAttribute('href');
        let isPantLink = url.indexOf('pant') !== -1;
        let isBoxerLink = url.indexOf('boxer') !== -1;
        if (isPantLink) {
          $a.setAttribute('href', `${ url }?view=${ pant_view }`);
        }
        if (isBoxerLink) {
          $a.setAttribute('href', `${ url }?view=${ boxer_view }`);
        }
      });
    }

    // UGC_Carousel
    Alpine.data('UGC_Carousel', () => ({
      cache: {},
      flags: {
        is_Mobile: window.matchMedia('(max-width: 640px)').matches
      },
      init() {
        this.InitSelf();
      },
      InitSelf() {
        let am = this;
        am.cache.$section = am.$el;
        am.cache.$swiper = am.cache.$section.querySelector('.swiper');
        am.InitCarousel();
      },
      InitCarousel() {
        let am = this;
        let slidesPerView_desk = am.cache.$section.style.getPropertyValue('--slides-desktop');
        let slidesPerView_mob = am.cache.$section.style.getPropertyValue('--slides-mobile');

        let swiper_options = {
          centeredSlides: true,
          loop: true,
          slidesPerView: slidesPerView_mob,
          spaceBetween: 25,
          autoplay: {
            delay: 2500,
          },          
          breakpoints: {
            641: {
              slidesPerView: 3
            },
            1024: {
              slidesPerView: slidesPerView_desk
            }
          },
          navigation: {
            nextEl: am.cache.$section.querySelector('.button-next'),
            prevEl: am.cache.$section.querySelector('.button-prev')
          }
        };
        new Swiper(am.cache.$swiper, swiper_options);
      }
    }));

    Alpine.data('DynamicStickyHeader', () => ({
      pos_scrollY: window.scrollY,
      cache: {
        $section_announce: document.querySelector('#shopify-section-announcement'),
        $section_header: document.querySelector('#shopify-section-header')
      },
      init() {
        let am = this;
        am.CheckHeaderSticky();
        document.addEventListener('scroll', Alpine.throttle((e) => {
          document.body.classList.add('scrolled');

          am.CheckHeaderSticky();
          am.pos_scrollY = window.scrollY;
        }), 1000);
      },
      CheckHeaderSticky() {
        let am = this;
        let headerHeight = am.cache.$section_header.offsetHeight + am.cache.$section_announce.offsetHeight;
        let is_scrolledTop = window.scrollY <= am.pos_scrollY;
        let is_pastHeader = window.scrollY > headerHeight;

        // console.log({
        //   y: window.scrollY,
        //   cacheY: am.pos_scrollY,
        //   is_scrolledTop: is_scrolledTop,
        //   is_pastHeader: is_pastHeader
        // })

        if (!is_pastHeader || is_scrolledTop || am.pos_scrollY == 0) {
          document.body.classList.add('dynamic-header-active')
        }
        else {
          document.body.classList.remove('dynamic-header-active')
        }
        // document.body.classList.toggle('dynamic-header-active', is_pastHeader || is_scrolledTop);
        // document.body.classList.toggle('dynamic-header-active', is_scrolledTop);
      }
    }));
  });
})();